import { refreshToken } from "@/core/components/auth/services";
import {
  getAccessToken,
  removeAllTokens,
  updateUserToken,
} from "@/core/components/auth/services/cookies";
import { clearAllChatData } from "@/core/utils/chatbot-storage";

let isRefreshing = false;
let pendingRefreshPromise: Promise<string> | null = null;

async function doRefreshToken(): Promise<string> {
  if (isRefreshing && pendingRefreshPromise) {
    return pendingRefreshPromise;
  }

  isRefreshing = true;
  pendingRefreshPromise = refreshToken()
    .then(({ token, refreshToken: newRefreshToken }) => {
      updateUserToken(token, newRefreshToken);
      return token;
    })
    .finally(() => {
      isRefreshing = false;
      pendingRefreshPromise = null;
    });

  return pendingRefreshPromise;
}

function buildAuthHeaders(token: string, base: HeadersInit = {}): HeadersInit {
  return {
    ...base,
    "Auth-Token": token,
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchWithTokenRefresh(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  const response = await fetch(url, {
    ...options,
    headers: buildAuthHeaders(getAccessToken() || "", options.headers),
  });

  if (response.status !== 401) return response;

  try {
    const newToken = await doRefreshToken();
    return fetch(url, {
      ...options,
      headers: buildAuthHeaders(newToken, options.headers),
    });
  } catch {
    removeAllTokens();
    clearAllChatData();
    throw new Error("user not logged");
  }
}
